// Zentraler App-Name — Umbenennung nur hier (und in public/site.webmanifest).
export const APP_NAME = 'Kuratier'
